import { render } from "./field_context_menu.vue?vue&type=template&id=e852be1c"
import script from "./field_context_menu.vue?vue&type=script&lang=js"
export * from "./field_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/signit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__